export default __webpack_public_path__ + "static/media/SEC3020.34I-38755_-22635_0.9258b431.jpg";